import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import AuthReducer from "./auth/reducer";

import ClientReducer from "./clients/reducer";
import QuoteReducer from "./quotes/reducer";
import InvoiceReducer from "./invoices/reducer";
import DashboardReducer from "./dashboard/reducer";
import NotificationReducer from "./notifications/reducer";
import CategoryReducer from "./categories/reducer";
import SubcategoryReducer from "./subcategories/reducer";
import ItemReducer from "./items/reducer";
import ConfigReducer from "./config/reducer";
import PaymantsInvoicingReducer from "./paymantsInvoicing/reducer";
import SectionReducer from "./section/reducer";
import PresetReducer from "./presetQuotes/reducer";
import TeamMemberReducer from "./teamMember/reducer";
import TourReducer from "./tour/reducer";
import AdminReducer from "./admin/reducer";
import billingInvoiceReducer from "./billings/reducer";
import PaymentReducer from "./payments/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  auth: AuthReducer,
  client: ClientReducer,
  quote: QuoteReducer,
  invoice: InvoiceReducer,
  dashboard: DashboardReducer,
  notification: NotificationReducer,
  category: CategoryReducer,
  subcategory: SubcategoryReducer,
  item: ItemReducer,
  config: ConfigReducer,
  paymantsInvoicing: PaymantsInvoicingReducer,
  section: SectionReducer,
  presetQuote: PresetReducer,
  teamMember: TeamMemberReducer,
  tours: TourReducer,
  admin: AdminReducer,
  billing: billingInvoiceReducer,
  payment: PaymentReducer,
});

export default rootReducer;
